import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useKnowledgeLibraries } from "./KnowledgeHook";
import { useDevLogging } from "@limitless/common/hooks/dev-logging/DevLoggingContext";
import { KnowledgeLibraryContextProvider } from "./KnowledgeLibraryContext";
const KnowledgeContext = /*#__PURE__*/createContext({});
export const KnowledgeContextProvider = ({
  children,
  ...rest
}) => {
  const hook = useKnowledgeLibraries();
  const {
    stateTracker
  } = useDevLogging();
  const context = useMemo(() => {
    stateTracker.trackState({
      knowledge: {
        libraries: hook.libraries
      }
    });
    return {
      ...hook
    };
  }, [hook.libraries]);
  return /*#__PURE__*/React.createElement(KnowledgeContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(KnowledgeLibraryContextProvider, rest, children));
};
export const useKnowledgeContext = () => {
  return useContext(KnowledgeContext);
};
KnowledgeContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  customTranslate: PropTypes.func
};